import axios from "axios";
import { useMutation } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useCreateBulkTransaction(options = {}) {
  const { accessToken } = useSession();

  const action = async (data) => {
    const formData = new FormData();
    formData.append("file", data.file);

    return axios.post(
      `${config.inventoryApiUrl}/v1/transaction-reports-uploads`,
      formData,
      {
        headers: {
          ...requestHeaders(accessToken),
          "Content-Type": "multipart/form-data",
        },
        params: {
          ...(data.validations ? {} : { validations: false }),
        },
        timeout: 15000,
      },
    );
  };

  const mutation = useMutation((data) => action(data), {
    onError: (error, variables, context) => {
      error.readableError = error.response?.data?.message;
      error.isTimeout =
        error?.code === "ECONNABORTED" || error.response?.status === 504;
    },
  });

  return {
    createBulkTransaction: mutation.mutateAsync,
    createBulkTransactionStatus: {
      ...mutation,
      isTimeout: mutation.isError && mutation.error?.isTimeout,
    },
  };
}
